import * as React from "react";

import HeroBanner from "../../../components/HeroBan";

//Brands
import Panasonic from "../../../images/brands/Panasonic.jpg";
import Mitsubishi from "../../../images/brands/Mitsubishi.jpg";
import Haier from "../../../images/brands/Haier.jpg";
import Daikin from "../../../images/brands/Daikin.jpg";

//Heatpumps
import HaierIndoor from "../../../images/heatpumps/Haier Indoor.jpg";
import HaierOutdoor from "../../../images/heatpumps/Haier Outdoor.jpg";
import PanasonicIndoor from "../../../images/heatpumps/Panasonic Indoor.jpg";
import PanasonicIndoor2 from "../../../images/heatpumps/Panasonic Indoor 2.jpg";
import PanasonicOutdoor from "../../../images/heatpumps/Panasonic Outdoor.jpg";

import SlideShow from "../../../components/slider";
import { useStaticQuery, graphql } from "gatsby";
import Layout from "../../../components/layout";

const AllProducts = ({ pageContext }) => {
  const wpdata = useStaticQuery(graphql`
    {
      wp {
        page(id: "residential/heat-pumps", idType: URI) {
          residentialHeatPump {
            heroBackgroundColor
            heroContent
            heroHeading
            heroImage {
              altText
              sourceUrl
            }
            heroLink {
              target
              title
              url
            }
            hpoItems {
              content
              heading
              link {
                title
                url
                target
              }
              image {
                altText
                sourceUrl
              }
            }
            summarContent
            summaryImage {
              altText
              sourceUrl
            }
            featuresItems {
              content
              heading
              image {
                altText
                sourceUrl
              }
            }
          }
        }
      }
    }
  `);
  const data = wpdata?.wp?.page?.residentialHeatPump || {};
  return (
    <Layout pageContext={pageContext}>
      <HeroBanner
        image={data?.heroImage?.sourceUrl}
        color={data?.heroBackgroundColor}
      >
        <h5>{data?.heroHeading}</h5>
        <p>{data?.heroContent}</p>
        <a href={data?.heroLink?.url} target={data?.heroLink?.target}>
          {data?.heroLink?.title}
        </a>
      </HeroBanner>
      <div className="w-full bg-black ">
        <div className=" py-20 text-center text-white mx-auto w-11/12 max-w-6xl">
          <div className="flex mx-auto h-28 w-auto mb-7">
            <img
              src={data?.summaryImage?.sourceUrl}
              alt={data?.summaryImage?.altText}
              className="w-full"
            />
          </div>
          <p
            className="text-2xl leading-8"
            dangerouslySetInnerHTML={{ __html: data?.summarContent }}
          ></p>
        </div>
      </div>

      <div className="flex flex-wrap justify-between max-w-7xl mx-auto py-20 w-11/12 md:w-4/5 lg:w-full xl:w-full 2xl:w-4/5 overflow-hidden text-black">
        {data?.hpoItems?.map((v, i) => (
          <div
            key={i}
            className="my-4 mx-auto max-w-sm w-1/2 overflow-hidden w-full md:w-full lg:w-1/3 xl:w-1/3"
          >
            <img
              className="w-full mx-auto mb-10"
              src={v?.image?.sourceUrl}
              alt={v?.image?.altText}
            />
            <h5 className="text-black text-4xl my-2">{v?.heading}</h5>
            <p className="lg:h-80 text-xl leading-9">{v?.content}</p>

            <a href={v?.link?.url} target={v?.link?.target}>
              <div className="bg-tan text-2xl text-black uppercase font-anton text-center w-full py-3 my-5 lg:my-auto">
                {v?.link?.title}
              </div>
            </a>
          </div>
        ))}
      </div>

      <div style={{ backgroundColor: "#F8F8F8" }} className="py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-20 lg:gap-y-10 max-w-7xl mx-10 sm:mx-auto divide-y-3 divide-tan">
          <ul className="flex flex-col">
            {data?.featuresItems
              .filter((v, i) => (i + 1) % 2 !== 0)
              .map((v, i) => (
                <li key={i} className="grid grid-cols-1 sm:grid-cols-6">
                  <div className="col-span-1 mt-0.5">
                    <div className="flex sm:w-full sm:mb-0 mb-5 max-w-76">
                      <img
                        src={v?.image?.sourceUrl}
                        className="w-full max-h-80"
                      />
                    </div>
                  </div>
                  <div className="col-span-5">
                    <h3 className="text-4xl text-black mb-2">{v?.heading}</h3>
                    <div
                      className=" text-xl leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: v?.content }}
                    ></div>
                    <div className="bg-tan w-2/3 sm:w-1/3 h-0.5 my-12 sm:my-14" />
                  </div>
                </li>
              ))}
          </ul>
          <ul className="flex flex-col">
            {data?.featuresItems
              ?.filter((v, i) => (i + 1) % 2 === 0)
              .map((v, i) => (
                <li key={i} className="grid grid-cols-1 sm:grid-cols-6">
                  <div className="col-span-1 w-11/12 mt-0.5">
                    <div className="flex sm:w-full sm:mb-0 mb-5 max-w-76">
                      <img
                        src={v?.image?.sourceUrl}
                        className="w-full max-h-80"
                      />
                    </div>
                  </div>

                  <div className="col-span-5 ">
                    <h3 className="text-4xl text-black mb-2">{v?.heading}</h3>
                    <div
                      className=" text-xl leading-relaxed"
                      dangerouslySetInnerHTML={{ __html: v?.content }}
                    ></div>

                    <div className="bg-tan w-2/3 sm:w-1/3 h-0.5 my-12 sm:my-14" />
                  </div>
                </li>
              ))}
          </ul>
        </div>
      </div>

      <div className="heat-pumps-logos flex flex-wrap items-center justify-center max-w-7xl my-28 mx-auto">
        <img className="px-2" src={Panasonic} alt="" />
        <img className="px-2" src={Mitsubishi} alt="" />
        <img className="px-2" src={Haier} alt="" />
        <img className="px-2" src={Daikin} alt="" />
      </div>
    </Layout>
  );
};

export default AllProducts;
